<input (ngModelChange)='inputChanged($event)' [ngModel]='displayedCode' pInputText placeholder='Sku' type='text' style="text-transform: lowercase">
